export default __webpack_public_path__ + "static/media/west.65bedd50.png";